// 富文本字段默认匹配规则
export const DEFAULT_FIELD_REGEX = /(\$\{[^\$]+?\})/g;
